export default __webpack_public_path__ + "static/media/Zahl-3.33e47aec.webp";